import { StatusPill } from "@vantage-hub/ui";
import type { StatusVariant } from "@vantage-hub/ui";

interface CertRow {
	id: string;
	insured: string;
	broker: string;
	initials: string;
	bcolor: string;
	type: string;
	value: string;
	status: StatusVariant;
	updated: string;
}

const rows: CertRow[] = [
	{
		id: "CERT-28491",
		insured: "Zurich Logistics Ltd",
		broker: "Marsh McLennan",
		initials: "ZL",
		bcolor: "#121A37",
		type: "Property CAT",
		value: "£2.50M",
		status: "active",
		updated: "12m ago",
	},
	{
		id: "CERT-28487",
		insured: "Allianz Freight SE",
		broker: "Aon Benfield",
		initials: "AF",
		bcolor: "#665014",
		type: "Marine Cargo",
		value: "£850K",
		status: "active",
		updated: "1h ago",
	},
	{
		id: "CERT-28483",
		insured: "Generali Shipping",
		broker: "Guy Carpenter",
		initials: "GS",
		bcolor: "#0E6A74",
		type: "Marine Hull",
		value: "£1.20M",
		status: "review",
		updated: "3h ago",
	},
	{
		id: "CERT-28481",
		insured: "AXA Industrial",
		broker: "Gallagher Re",
		initials: "AI",
		bcolor: "#2E7A2A",
		type: "General Liability",
		value: "£4.00M",
		status: "active",
		updated: "5h ago",
	},
	{
		id: "CERT-28479",
		insured: "Tokio Pacific Ltd",
		broker: "Howden Tiger",
		initials: "TP",
		bcolor: "#9C3636",
		type: "Cyber Risk",
		value: "£600K",
		status: "pending",
		updated: "8h ago",
	},
	{
		id: "CERT-28476",
		insured: "Munich Re Syndicate",
		broker: "Lockton Re",
		initials: "MR",
		bcolor: "#1E2855",
		type: "Aviation Hull",
		value: "£950K",
		status: "revoked",
		updated: "Yesterday",
	},
	{
		id: "CERT-28472",
		insured: "Chubb Marine Corp",
		broker: "BMS Re",
		initials: "CM",
		bcolor: "#5B6280",
		type: "Property Pro Rata",
		value: "£3.20M",
		status: "active",
		updated: "Yesterday",
	},
];

export function RecentCertsTable() {
	return (
		<div className="divide-y divide-border/60">
			{rows.map((r) => (
				<div
					key={r.id}
					className="flex min-w-0 items-center gap-3 px-5 py-3.5 transition-colors hover:bg-muted/30"
				>
					{/* Avatar */}
					<div
						className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg text-[10.5px] font-semibold text-white"
						style={{ background: r.bcolor }}
					>
						{r.initials}
					</div>

					{/* ID + company */}
					<div className="min-w-0 flex-1">
						<div className="flex items-baseline gap-1.5">
							<span className="font-mono text-[12px] font-medium text-foreground">
								{r.id}
							</span>
							<span className="text-[11px] text-muted-foreground">· {r.updated}</span>
						</div>
						<div className="truncate text-[11.5px] text-muted-foreground">
							{r.insured} · {r.broker}
						</div>
					</div>

					{/* Type badge */}
					<span className="flex-shrink-0 rounded-md border border-border bg-muted/50 px-2 py-0.5 text-[11px] font-medium text-muted-foreground">
						{r.type}
					</span>

					{/* Value */}
					<span className="w-[64px] flex-shrink-0 text-right text-[13px] font-semibold tabular-nums text-foreground">
						{r.value}
					</span>

					{/* Status */}
					<div className="flex-shrink-0">
						<StatusPill status={r.status} />
					</div>
				</div>
			))}
		</div>
	);
}
